import * as React           from "react";

import "./admin-ad-budget-card-container.scss";

import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {UseState}                   from "@Common/react/use-state";
import {Pagination}                 from "@Common/ui-components/heavy/common/design2/data-table/pagination";
import {PageList}                   from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PAGE_SIZE_ALL, PageSize}    from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {getPageSummary}             from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {AdminAdBudgetCard}          from "./admin-ad-budget-card/admin-ad-budget-card";
import {pageSizesAdminAdBudget,
        helperTextAdminAdBudget}    from "@Xpresso/routes/account/admin/accounting/admin-ad-budgets-route/admin-ad-budgets-route"
import {InlineSelect}               from "../inline-select/inline-select";
import {faCaretDown, faCaretUp}     from "../../../../../../../node_modules/@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "../../../../../../../node_modules/@fortawesome/react-fontawesome";

export const AdminAdBudgetCardContainer = ({selectedAgents}) => cs(
    consumeContext("apis"),
    ["pageSize", (_, next) => UseState({_key: "pageSize", initValue: PAGINATION_MIN, next})],
    ["sortAscending", ({}, next) => UseState({_key: "sortAscending", initValue: true, next})],
    ["sortedRows", ({sortAscending}, next) => next(sortedAgents(selectedAgents.value, sortAscending.value))],
    ["pagination", ({pageSize, sortedRows}, next) => Pagination({
        _key: JSON.stringify(pageSize),
        pageSize: pageSize.value,
        rows: sortedRows,
        next,
    })],
    ["displayedRows", ({pagination, sortedRows}, next) => next(pagination?.active ? pagination.getDisplayedRows() : sortedRows)],
    ({apis, displayedRows, pageSize, pagination, sortAscending}) => (
        <div className="admin-ad-budget-card-container-dxdt2">
            <div className="note" xd-qa-type="label" xd-qa-name="Note">
               {helperTextAdminAdBudget}
            </div>
            {selectedAgents.value.length > 0 ? (
                <>
                    <div className="header" >
                        <div className="allow-user">
                            {InlineSelect({
                                label: "ALLOW",
                                disabled: selectedAgents.value.length === 0,
                                items: itemsAdBudgetToggleAll({apis, selectedAgents})
                            })}
                            <div 
                                className="user-text"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    pagination.state.onChange(0)
                                    if(sortAscending.value) {
                                        sortAscending.onChange(false)
                                        return
                                    }
                                    sortAscending.onChange(true)
                                }} >
                                USER NAME
                                <FontAwesomeIcon
                                    className="icon"
                                    icon={sortAscending.value ? faCaretUp : faCaretDown}
                                    xd-qa-type="icon"
                                    xd-qa-name="USER Sort Caret"
                                />
                            </div>
                        </div>
                        <div className="amount-text">
                            AMOUNT
                        </div>
                    </div>
                    {displayedRows.map((agent, i) => (
                        <React.Fragment key={i}>
                            {AdminAdBudgetCard({selectedAgents, agent})}
                        </React.Fragment>
                    ))}
                    {selectedAgents.value.length > PAGINATION_MIN &&
                        <>
                            <div className="controls">
                                {PageSize({
                                    state: pageSize, 
                                    xdQaNamePrefix: "Pending Orders",
                                    sizes: pageSizesAdminAdBudget,
                                    extraSizes: [PAGE_SIZE_ALL],
                                    pageSizeMessage: ""
                                })}               
                                {pagination.active && PageList(pagination)}
                            </div>
                            {getPageSummary({
                                pageIndex: pagination.state.value,
                                pageSize: pageSize.value,
                                count: selectedAgents.value.length
                            })}
                        </>
                    }
                </>
            ) : (
                null
            )}
        </div>
    )
)

const PAGINATION_MIN = 10

const sortedAgents = (agents, sortAscending) => {
    if(!agents) {
        return []
    }
    if(!agents.length) {
        return []
    }
    
    const ascending = sortAscending ? 1 : -1
    const sorted = agents.sort((a, b) => {
        const first = agentDisplay(a).toLowerCase()
        const second = agentDisplay(b).toLowerCase()
        if(second < first) {
            return ascending
        }
        if(second > first) {
            return -1 * ascending
        }
        return 0
    })

    return sorted
}

export const agentDisplay = (agentOuter) => {
    const agent = agentOuter.agent

    if(agent.hasOwnProperty('name')) {
        return agent.name
    }

    if(agent.hasOwnProperty('agentNameFirst')) {
        if(agent.hasOwnProperty('agentNameLast')) {
            return `${agent.agentNameFirst} ${agent.agentNameLast}`
        }
    }

    if(agent.hasOwnProperty('idAgent')) {
        return agent.idAgent
    }

    return null
}

const itemsAdBudgetToggleAll = ({apis, selectedAgents}) => 
[
    {
        label: "Allow All",
        onSelect: () => {
            selectedAgents.change((bs) => bs.map((b1) => ({
                ...b1,
                allow: true,
            })))
            selectedAgents?.value.map((b) => {
                apis.next.adBudgets.setUserAdBudget({
                    idBranch: b.agent.idBranch,
                    list: [{
                        idAgent: b.agent.idAgent,
                        amount: b.amount,
                        status: true,
                    }],
                })
            })
        },
    },
    {
        label: "Disallow All",
        onSelect: () => {
            selectedAgents.change((bs) => bs.map((b1) => ({
                ...b1,
                allow: false,
            })))
            selectedAgents?.value.map((b) => {
                apis.next.adBudgets.setUserAdBudget({
                    idBranch: b.agent.idBranch,
                    list: [{
                        idAgent: b.agent.idAgent,
                        amount: b.amount,
                        status: false,
                    }],
                })
            })
        },
    },
]
